// Simple confetti effect utility
export const createConfetti = (element, options = {}) => {
  const {
    particleCount = 50,
    colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'],
    duration = 2000
  } = options;

  const rect = element.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;

  // Create container for confetti
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.pointerEvents = 'none';
  container.style.zIndex = '9999';
  document.body.appendChild(container);

  // Create particles
  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    const color = colors[Math.floor(Math.random() * colors.length)];
    const size = Math.random() * 8 + 4;
    const angle = Math.random() * Math.PI * 2;
    const velocity = Math.random() * 300 + 200;
    const rotationSpeed = Math.random() * 360 - 180;

    particle.style.position = 'absolute';
    particle.style.left = `${centerX}px`;
    particle.style.top = `${centerY}px`;
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    particle.style.backgroundColor = color;
    particle.style.borderRadius = '50%';
    particle.style.pointerEvents = 'none';

    container.appendChild(particle);

    // Animate particle
    const startTime = Date.now();
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = elapsed / duration;

      if (progress >= 1) {
        particle.remove();
        return;
      }

      const x = centerX + Math.cos(angle) * velocity * progress;
      const y = centerY + Math.sin(angle) * velocity * progress + 0.5 * 9.8 * progress * progress * 100;
      const rotation = rotationSpeed * progress;

      particle.style.left = `${x}px`;
      particle.style.top = `${y}px`;
      particle.style.transform = `rotate(${rotation}deg)`;
      particle.style.opacity = 1 - progress;

      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }

  // Remove container after animation
  setTimeout(() => {
    container.remove();
  }, duration);
};

// Confetti for success
export const createSuccessConfetti = (element) => {
  createConfetti(element, {
    particleCount: 100,
    colors: ['#10b981', '#34d399', '#6ee7b7'],
    duration: 2000
  });
};

// Confetti for achievement
export const createAchievementConfetti = (element) => {
  createConfetti(element, {
    particleCount: 150,
    colors: ['#f59e0b', '#fbbf24', '#fcd34d', '#fef3c7'],
    duration: 3000
  });
};

// Confetti for level up
export const createLevelUpConfetti = (element) => {
  createConfetti(element, {
    particleCount: 200,
    colors: ['#3b82f6', '#60a5fa', '#93c5fd', '#dbeafe'],
    duration: 3000
  });
};



